/**
 * A future similar to Python's asyncio.Future. Allows to resolve or reject
 * outside of the executor.
 */
export class Future<ResolveType = void, RejectType = Error> extends Promise<ResolveType> {
  private _done: boolean;
  private _resolve: (value?: ResolveType | PromiseLike<ResolveType>) => void;
  private _reject: (reason?: RejectType) => void;

  constructor(executor?: CallableFunction) {
    let resolve, reject;
    super((resolve_, reject_) => {
      resolve = resolve_;
      reject = reject_;
      if (executor) {
        return executor(resolve_, reject_);
      }
    });

    this._done = false;
    this._resolve = resolve;
    this._reject = reject;
  }

  get done() {
    return this._done;
  }

  resolve(args: ResolveType) {
    this._done = true;
    return this._resolve(args);
  }

  reject(args: RejectType) {
    this._done = true;
    return this._reject(args);
  }
}

// I can't believe there isn't a standard way to do this (correct me and burn this to the ground if I'm wrong)
const i32limit = Math.pow(2, 31);

export function isValidInt32(val: number) {
  return val > -i32limit && val < i32limit;
}
